import React, { useEffect, useState } from 'react';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { AthleteProps, ExternalPriceProps, GolfCourseProps, GolfLeaderProps, GolfScorecardProps, TournamentProps } from "../../../store/types/sr_svc"
import { Image, ImageBackground, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Icon } from 'react-native-elements';
import { event_getAllPrices, event_getScorecardByAthlete } from '../../../store/actionsv1/events';
import GolfRoundScoreCard from './GolfScoreCard';
import { MarketProps, TradeProps } from '../../../store/types/mk_svc';
import { market_getOddsLabel } from '../helpers/markets';
import PriceHistoryCard from './PriceHistoryChart';
import MarketCard from '../components/MarketCard';
import { market_setDraftOrder } from '../../../store/actionsv1/markets';
import { trade_getOrderFromTrade } from '../helpers/trades';
import { navigate } from '../../../navigation/RootNavigation';
import moment from 'moment';

type GolfLeaderCardProps = {
    golf_course:GolfCourseProps,
    golf_leader:GolfLeaderProps,
    tournament:TournamentProps,
    market?:MarketProps,
    width:number,
}

const GolfLeaderCard = ({ golf_course, tournament, golf_leader, market, width } : GolfLeaderCardProps) => {
    const [ expanded, setExpanded ] = useState(false);
    const [ scorecard_loading, setScorecardLoading ] = useState(false);
    const [ card_width, setCardWidth ] = useState(0);
    const [ visible_round, setVisibleRound ] = useState<undefined|number>(undefined)
    const [ select_round_visible, setSelectRoundVisible ] = useState(false);
    
    const dispatch = useDispatch();
    const market_type:'FREE'|'FOR_MONEY' = useSelector((state:any) => state.auth.market_type, (left, right) => left == right);
    const athlete:AthleteProps | undefined = useSelector((state:any) => state.event.athletes_list.athletes.find(a => a.athlete_id == golf_leader.athlete_id), (left,right) => left?.athlete_id == right?.athlete_id);
    const golf_scorecards_list: { updated:number, golf_scorecards:GolfScorecardProps[] } = useSelector((state:any) => state.event.golf_scorecards_list, (left, right) => left.updated == right.updated);
    const golf_scorecards = golf_scorecards_list.golf_scorecards.filter(gs => gs.athlete_id == golf_leader.athlete_id && gs.tournament_id == golf_leader.tournament_id && gs.round_number == visible_round)
    
    //Get All prices history
    const prices:ExternalPriceProps[] = useSelector((state:any) => state.event.prices.filter((p:ExternalPriceProps) => p.event_id == golf_leader.tournament_id && p.event_type == 'tournament' && p.market_id == market?.market_id && p.participant_id == golf_leader.athlete_id), (left, right) => left.length == right.length)
    //Get latest trade from Markets service
    const latest_trades_list: undefined | TradeProps[] = useSelector((state:any) => state.market.latest_trades[`tournament:${golf_leader.tournament_id}`], (left,right) => left == right);
    let trade:TradeProps | undefined = undefined
    if(latest_trades_list){ trade = latest_trades_list.find(t => t.market_type == market_type && t.market_id == market?.market_id && t.side_id == golf_leader.athlete_id && t.side == market.trade_side) }
    //Get the player's current round
    let current_round = golf_leader.leader_rounds.find(r => r.status == 'closed')
    if(!current_round){ current_round = golf_leader.leader_rounds.find(r => r.round_number == 1) }
    golf_leader.leader_rounds.sort((a,b) => b.round_number - a.round_number)[0]    
    let visible_leader_round = golf_leader.leader_rounds.find(lr => lr.round_number == visible_round)
    
    const order_stats = useSelector((state:any) => state.market.order_stats[`tournament:${tournament.tournament_id}`] ?? [], (left, right) => left == right);
    const order_stat = order_stats.find(s => s.market_id == market?.market_id && s.side_id == athlete?.athlete_id);

    useEffect(() => {
        if(!visible_round){ return }
        getScorecardFromServer(visible_round)
    },[visible_round])

    const handleExpand = () => {
        if(expanded){
            setExpanded(false)
            setVisibleRound(undefined)
            return
        }
        setExpanded(true)        
        setVisibleRound(current_round?.round_number??1)
    }


    const handleSelectTrade = (trade:TradeProps) => {
        if(!tournament){ return }
        if(!athlete){ return }
        return dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))
    }

    const getScorecardFromServer = async(round_number:number) => {
        setScorecardLoading(true);
        await dispatch(event_getScorecardByAthlete(golf_leader.tournament_id, golf_leader.athlete_id, round_number.toString()))
        await dispatch(event_getAllPrices(golf_leader.tournament_id, 'tournament', 0, golf_leader.athlete_id))
        setScorecardLoading(false);
    }
    if(!athlete){ return <></> }
    let round_progress = visible_leader_round?.thru == 18 ? 'F': `Thru ${visible_leader_round?.thru}`
    return (
        <View style={{ backgroundColor:golf_leader.cut?Colors.shades.shade100:Colors.shades.white }}>
            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:14, borderRadius:8, borderBottomRightRadius:expanded?0:8, borderBottomLeftRadius:expanded?0:8, borderWidth:1, borderColor:Colors.shades.shade600, borderBottomWidth:expanded?0:1 }} onPress={() => handleExpand()}>
                {golf_leader.place != 999 && golf_leader.tee_time ?
                <Text style={{ flex:1, margin:2 }} size={14} color={Colors.brand.midnight} weight='regular'>{golf_leader.place}</Text>
                :
                <Text style={{ flex:1, margin:2 }} size={14} color={Colors.brand.midnight} weight='regular'>{moment(golf_leader.tee_time).format('h:mm')}</Text>
                }
                <View style={{ flex:5, margin:2 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='regular'>{athlete.first_name} {athlete.last_name}<Text style={{ marginTop:4 }} size={14} color={Colors.brand.midnight} weight='bold'>{golf_leader.status=='active'&&trade&&market?` (${market_getOddsLabel(trade.odds)})`:''}</Text></Text>
                    
                </View>
                <Text style={{ flex:1, margin:2 }} size={14} color={Colors.brand.midnight} weight='regular' textAlign='right'>{golf_leader.score_label}</Text>
                <Icon name={expanded?'chevron-up':'chevron-down'} type='feather' color={Colors.brand.midnight} size={16} />
            </TouchableOpacity>
            {expanded ?
                <View nativeID='golf_leader_expanded' style={{ borderBottomRightRadius: 8, borderBottomLeftRadius:8, borderColor:Colors.shades.shade600, borderWidth:1 }}>
                    <View>
                        <View nativeID='athlete_header' style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                            <View>
                                <Image
                                    source={athlete.image?.url??require('../../../assets/images/default-avatar.png')}
                                    style={{ height:50, width:50, borderRadius:4 }}
                                />
                            </View>
                            <View style={{ marginLeft:10 }}>
                                <Text size={16} color={Colors.brand.midnight} weight='bold'>{athlete.first_name} {athlete.last_name}</Text>
                                <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>World Golf Ranking: {golf_leader.rank < 200 ? golf_leader.rank : `200+`}</Text>
                            </View>
                            {market && golf_leader.status == 'active' ?
                            <View style={{ flex:1, marginLeft:10, padding:5, borderRadius:8, backgroundColor:Colors.shades.shade100 }}>
                                <Text size={14} color={Colors.brand.midnight} weight='semibold' textAlign='center'>{market.type}</Text>
                                <MarketCard 
                                    market={market}
                                    event_id={golf_leader.tournament_id}
                                    event_type='tournament'
                                    align='horizontal'
                                    side_array={[
                                        { side: market.trade_side, side_id: golf_leader.athlete_id },
                                        { side: market.side_options.find(o => o.side != market.trade_side)?.side, side_id: golf_leader.athlete_id }
                                    ]}
                                    onPress={(trade) => handleSelectTrade(trade)}
                                />
                            </View>
                            :<></>}
                        </View>
                        {market?
                        <TouchableOpacity style={{ flexDirection:'row', padding:10, borderTopWidth:1, borderColor:Colors.shades.shade600 }} onPress={() => {
                            navigate('Market', { event_id:golf_leader.tournament_id, event_type: 'tournament', market_id: market.market_id, participant_id:golf_leader.athlete_id, participant_type:'athlete' })
                        }}>
                            <Text style={{ flex:1 }} size={14} color={Colors.brand.electric} weight='regular' textAlign='left'>{order_stat?.open_order_count ?? 0} Open Orders</Text>
                            <Text size={14} color={Colors.brand.electric} weight='regular' textAlign='right'>Markets & Analysis</Text>
                        </TouchableOpacity>
                        :<></>}
                    </View>
                    <View nativeID='scorecard' style={{ }}>
                        <ImageBackground style={{ flexDirection:'row', width:width*0.75 }} source={require('../../../assets/images/diagnal_header.png')}>
                            <Text size={14} weight='semibold' color={Colors.shades.white} style={{ padding:10 }}>Scorecard</Text>
                        </ImageBackground>
                        <View nativeID='round_select' style={{ padding:10, paddingBottom:0, flexDirection:'row', alignItems:'center', justifyContent:'space-between' }}>
                            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:22, borderWidth:1, borderColor:Colors.brand.electric }} onPress={() => setSelectRoundVisible(true)}>
                                <Text style={{ marginRight:3 }} size={14} color={Colors.brand.electric}>Round {visible_round}</Text>
                                <Icon name='chevron-down' type='feather' color={Colors.brand.electric} size={14}/>
                            </TouchableOpacity>
                            {visible_leader_round ?
                            <View style={{ padding:10, flexDirection:'row', alignItems:'center', borderRadius:8, backgroundColor:Colors.shades.shade100 }}>
                                <Text size={14} color={Colors.brand.midnight} textAlign='right'>{visible_leader_round.score}</Text>
                                <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.midnight} textAlign='right'>{round_progress}</Text>
                            </View>
                            :<></>}
                        </View>
                        <View nativeID='leader_rounds'>
                            <GolfRoundScoreCard
                                width={width}
                                golf_course={golf_course}
                                golf_scorecards={golf_scorecards}
                            />
                        </View>
                        {select_round_visible ?
                        <View style={{ position:'absolute', top:10, left:10, minWidth:140, borderRadius:8, backgroundColor:Colors.shades.white,  shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }}>
                            {golf_leader.leader_rounds.map(lr => {
                                return (
                                    <TouchableOpacity style={{ padding:10, borderBottomWidth:1, borderColor:Colors.shades.shade600 }} onPress={() => {
                                        setSelectRoundVisible(false);
                                        setVisibleRound(lr.round_number)
                                    }}>
                                        <Text size={14} color={Colors.brand.electric} weight='regular'>Round {lr.round_number}</Text>
                                    </TouchableOpacity>
                                )
                            })}
                        </View>
                        :<></>}
                    </View>
                    {market ?
                    <View nativeID='price_history' style={{ marginTop:10, margin:10 }} onLayout={(ev) => {
                        const { width } = ev.nativeEvent.layout;
                        setCardWidth(width)
                    }}>
                        <ImageBackground style={{ flexDirection:'row', width:width*0.75 }} source={require('../../../assets/images/diagnal_header.png')}>
                            <Text size={14} weight='semibold' color={Colors.shades.white} style={{ padding:10 }}>{market.description}</Text>
                        </ImageBackground>
                        <View style={{ marginTop:10 }}>
                            <PriceHistoryCard
                                level='freemium'
                                trades={[]}
                                width={card_width}
                                external_prices={prices}
                            />
                        </View>
                    </View>
                    :<></>}
                </View>
            :<></>}
        </View>
    )
}

const areEqual = (left:GolfLeaderCardProps, right:GolfLeaderCardProps) => {
    if(left.golf_leader.athlete_id != right.golf_leader.athlete_id){ return false }
    if(left.market?.market_id != right.market?.market_id){ return false }
    if(left.width != right.width){ return false }
    if(left.tournament.tournament_id != right.tournament.tournament_id){ return false }
    return true
}

export default React.memo(GolfLeaderCard, areEqual)